import React, { useState, useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import './EmergencyBar.css';

const EmergencyBar = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Check if user has dismissed the bar before
    const dismissed = localStorage.getItem('emergency-bar-dismissed');
    if (dismissed === 'true') {
      setIsVisible(false);
    }
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('emergency-bar-dismissed', 'true');
  };

  if (!isVisible) return null;

  return (
    <div className="emergency-bar">
      <div className="emergency-bar-content">
        <span className="emergency-icon">🆘</span>
        <span className="emergency-text">
          Atención de Emergencia 24/7: <strong>+56 9 3292 1831</strong>
        </span>
        <a 
          href="https://wa.me/56932921831?text=Necesito%20ayuda%20urgente" 
          target="_blank" 
          rel="noopener noreferrer"
          className="emergency-whatsapp"
        >
          WhatsApp
        </a>
      </div>
      <button 
        onClick={handleDismiss} 
        className="emergency-close"
        aria-label="Cerrar barra de emergencia"
      >
        <FiX />
      </button>
    </div>
  );
};

export default EmergencyBar;
